class ProductWithSlider {
  static DESKTOP_MEDIA_QUERY = '(min-width: 990px)';
  static SCROLL_EDGE_THRESHOLD = 8;

  static SPLIDE_OPTIONS = {
    width: '100vw',
    perMove: 1,
    perPage: 1,
    type: 'loop',
    rewind: true,
    pagination: false,
    height: '100vh',
    gap: '50%',
    padding: { right: '50%' },
    breakpoints: {
      989: {
        perPage: 1,
        padding: 0,
        gap: 0,
      },
    },
  };

  constructor(root) {
    this.root = root;
    this.scroller = root.querySelector('.product__container-center');
    this.scrollHint = root.querySelector('[data-scroll-hint]');
    this.splideElement = root.querySelector('[id^="splide__main-product-with-slider--"]');
    this.desktopMediaQuery = window.matchMedia(ProductWithSlider.DESKTOP_MEDIA_QUERY);

    this.onWheel = this.onWheel.bind(this);
    this.updateScrollHint = this.updateScrollHint.bind(this);
  }

  init() {
    if (!this.scroller) return;

    this.initSplide();
    this.initScrollChaining();
    this.initScrollHint();
  }

  initSplide() {
    if (!this.splideElement || typeof Splide === 'undefined') return;

    this.splide = new Splide(this.splideElement, ProductWithSlider.SPLIDE_OPTIONS);
    this.splide.mount();
  }

  initScrollChaining() {
    this.root.addEventListener('wheel', this.onWheel, { passive: false, capture: true });
    this.scroller.addEventListener('scroll', this.updateScrollHint, { passive: true });
    window.addEventListener('resize', this.updateScrollHint);
    this.desktopMediaQuery.addEventListener('change', this.updateScrollHint);
  }

  initScrollHint() {
    if (!this.scrollHint) return;

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.updateScrollHint);
      this.resizeObserver.observe(this.scroller);
    }

    this.updateScrollHint();
  }

  isDesktop() {
    return this.desktopMediaQuery.matches;
  }

  hasOverflow() {
    const { scrollHeight, clientHeight } = this.scroller;
    return scrollHeight - clientHeight > ProductWithSlider.SCROLL_EDGE_THRESHOLD;
  }

  isAtTop() {
    return this.scroller.scrollTop <= ProductWithSlider.SCROLL_EDGE_THRESHOLD;
  }

  isAtBottom() {
    const { scrollTop, clientHeight, scrollHeight } = this.scroller;
    return scrollTop + clientHeight >= scrollHeight - ProductWithSlider.SCROLL_EDGE_THRESHOLD;
  }

  scrollBy(delta) {
    const maxScrollTop = this.scroller.scrollHeight - this.scroller.clientHeight;
    this.scroller.scrollTop = Math.max(0, Math.min(this.scroller.scrollTop + delta, maxScrollTop));
    this.updateScrollHint();
  }

  onWheel(event) {
    if (!this.isDesktop() || !this.hasOverflow()) return;

    const { deltaY } = event;
    if (!deltaY) return;

    const scrollingDown = deltaY > 0;
    const canConsumeScroll = scrollingDown ? !this.isAtBottom() : !this.isAtTop();

    if (!canConsumeScroll) return;

    event.preventDefault();
    this.scrollBy(deltaY);
  }

  updateScrollHint() {
    if (!this.scrollHint) return;

    const shouldHide = !this.hasOverflow() || this.isAtBottom();
    this.scrollHint.classList.toggle('is-hidden', shouldHide);
  }
}

class ProductFloatingBuyButton {
  static HIDE_DELAY_MS = 500;
  static VISIBILITY_RATIO = 1.3;

  constructor(button) {
    this.button = button;
    this.appearAfterScroll = window.innerHeight / ProductFloatingBuyButton.VISIBILITY_RATIO;
    this.lastScrollTop = 0;
    this.hideTimeout = null;

    this.onScroll = this.onScroll.bind(this);
  }

  init() {
    if (!this.button) return;

    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  show() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    this.button.classList.remove('hidden', 'hide');
  }

  hide() {
    this.button.classList.add('hide');
    this.hideTimeout = setTimeout(() => {
      this.button.classList.add('hidden');
      this.hideTimeout = null;
    }, ProductFloatingBuyButton.HIDE_DELAY_MS);
  }

  onScroll() {
    const currentScrollTop = window.scrollY;
    const isScrollingDown = currentScrollTop > this.lastScrollTop;

    if (currentScrollTop > this.appearAfterScroll && isScrollingDown) {
      this.show();
    } else if (currentScrollTop <= this.appearAfterScroll && !isScrollingDown) {
      this.hide();
    }

    this.lastScrollTop = Math.max(currentScrollTop, 0);
  }
}

function initProductWithSliders() {
  document.querySelectorAll('product-info .main-product-with-slider__container').forEach((container) => {
    const root = container.closest('product-info');
    if (!root || root.dataset.productSliderInitialized === 'true') return;

    root.dataset.productSliderInitialized = 'true';
    new ProductWithSlider(root).init();
  });
}

let floatingBuyButton = null;

function initFloatingBuyButton() {
  const button = document.querySelector('.product-form__floating-button');
  if (!button || button.dataset.floatingInitialized === 'true') return;

  button.dataset.floatingInitialized = 'true';
  floatingBuyButton = new ProductFloatingBuyButton(button);
  floatingBuyButton.init();
}

function destroyFloatingBuyButton() {
  if (!floatingBuyButton) return;

  window.removeEventListener('scroll', floatingBuyButton.onScroll);
  if (floatingBuyButton.hideTimeout) clearTimeout(floatingBuyButton.hideTimeout);
  floatingBuyButton = null;
}

function initMainProductWithSlider() {
  initProductWithSliders();
  initFloatingBuyButton();
}

document.addEventListener('DOMContentLoaded', initMainProductWithSlider);
document.addEventListener('product-info:loaded', initProductWithSliders);
document.addEventListener('shopify:section:load', (event) => {
  if (!event.target.querySelector('.product-form__floating-button')) return;
  initFloatingBuyButton();
});
document.addEventListener('shopify:section:unload', (event) => {
  if (!event.target.querySelector('.product-form__floating-button')) return;
  destroyFloatingBuyButton();
});
